import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { hasModule, hasPermission } from './permissions';

export function createPermissionGuard(...required: readonly string[]): CanActivateFn {
  return (_, state) => {
    const keycloak = inject(Keycloak);
    const router = inject(Router);
    if (hasPermission(keycloak, ...required)) return true;
    if (!keycloak.authenticated) return router.createUrlTree(['/']);
    return router.createUrlTree(['/no-access'], { queryParams: { returnUrl: state.url } });
  };
}

/**
 * Module entitlement AND one of the permissions. `createPermissionGuard` is disjunctive, so
 * listing the module alongside the permissions there would let either one alone pass.
 */
export function createModuleGuard(
  module: string,
  ...required: readonly string[]
): CanActivateFn {
  return (_, state) => {
    const keycloak = inject(Keycloak);
    const router = inject(Router);
    if (hasModule(keycloak, module) && hasPermission(keycloak, ...required)) return true;
    if (!keycloak.authenticated) return router.createUrlTree(['/']);
    return router.createUrlTree(['/no-access'], { queryParams: { returnUrl: state.url } });
  };
}

export function createPermissionCanMatch(...required: readonly string[]): CanMatchFn {
  return () => hasPermission(inject(Keycloak), ...required);
}
